"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
/* generic function for adding a message to message area through JS alone */
function addMessage(status, text) {
    jquery_1["default"]('.messages').addClass('new').empty()
        .append('<ul><li class="' + status + '">' + text + '</li></ul>');
    var addMsgTimeout = setTimeout(function () {
        jquery_1["default"]('.messages').addClass('appear');
        clearTimeout(addMsgTimeout);
    }, 100);
}
window.addMessage = addMessage;
function escapeHtml(text) {
    var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        '\'': '&#039;'
    };
    return text.replace(/[&<>"']/g, function (char) { return map[char]; });
}
window.escapeHtml = escapeHtml;
function initTagField(id, autocompleteUrl, options) {
    var finalOptions = Object.assign({
        autocomplete: { source: autocompleteUrl },
        preprocessTag: function (val) {
            // Double quote a tag if it contains a space
            // and if it isn't already quoted.
            if (val && val[0] !== '"' && val.indexOf(' ') > -1) {
                return '"' + val + '"';
            }
            return val;
        },
    }, options);
    jquery_1["default"]('#' + id).tagit(finalOptions);
}
window.initTagField = initTagField;
/*
 * Enables a "dirty form check", prompting the user if they are navigating away
 * from a page with unsaved changes, as well as optionally controlling other
 * behaviour via a callback
 *
 * It takes the following parameters:
 *
 *  - formSelector - A CSS selector to select the form to apply this check to.
 *
 *  - options - An object for passing in options. Possible options are:
 *  - confirmationMessage - The message to display in the prompt.
 *  - alwaysDirty - When set to true the form will always be considered dirty,
 *    prompting the user even when nothing has been changed.
 *  - commentApp - The CommentApp used by the commenting system, if the dirty check
 *    should include comments
 *  - callback - A function to be run when the dirty status of the form, or the comments
 *    system (if using) changes, taking formDirty, commentsDirty as arguments
*/
function enableDirtyFormCheck(formSelector, options) {
    var $form = jquery_1["default"](formSelector);
    var confirmationMessage = options.confirmationMessage || ' ';
    var alwaysDirty = options.alwaysDirty || false;
    var commentApp = options.commentApp || null;
    var callback = options.callback || null;
    var initialData = null;
    var formSubmitted = false;
    var updateCallback = function (formDirty, commentsDirty) {
        if (callback) {
            callback(formDirty, commentsDirty);
        }
    };
    $form.on('submit', function () {
        formSubmitted = true;
    });
    var isDirty = alwaysDirty;
    var isCommentsDirty = false;
    var updateIsCommentsDirtyTimeout = -1;
    if (commentApp) {
        isCommentsDirty = commentApp.selectors.selectIsDirty(commentApp.store.getState());
        commentApp.store.subscribe(function () {
            // Update on a timeout to match the timings for responding to page form changes
            clearTimeout(updateIsCommentsDirtyTimeout);
            updateIsCommentsDirtyTimeout = setTimeout(function () {
                var newIsCommentsDirty = commentApp.selectors.selectIsDirty(commentApp.store.getState());
                if (newIsCommentsDirty !== isCommentsDirty) {
                    isCommentsDirty = newIsCommentsDirty;
                    updateCallback(isDirty, isCommentsDirty);
                }
            }, isCommentsDirty ? 3000 : 300);
        });
    }
    updateCallback(isDirty, isCommentsDirty);
    var updateIsDirtyTimeout = -1;
    var isFormDirty = function () {
        if (alwaysDirty) {
            return true;
        }
        else if (!initialData) {
            return false;
        }
        var formData = new FormData($form[0]);
        var keys = Array.from(formData.keys()).filter(function (key) { return !key.startsWith('comments-'); });
        if (keys.length !== initialData.size) {
            return true;
        }
        return keys.some(function (key) {
            var newValue = formData.getAll(key);
            var oldValue = initialData.get(key);
            if (newValue === oldValue) {
                return false;
            }
            else if (Array.isArray(newValue) && Array.isArray(oldValue)) {
                return newValue.length !== oldValue.length || newValue.some(function (value, index) { return value !== oldValue[index]; });
            }
            return false;
        });
    };
    var updateIsDirty = function () {
        var previousIsDirty = isDirty;
        isDirty = isFormDirty();
        if (previousIsDirty !== isDirty) {
            updateCallback(isDirty, isCommentsDirty);
        }
    };
    // Delay snapshotting the form’s data to avoid race conditions with form widgets that might process the values.
    // User interaction with the form within that delay also won’t trigger the confirmation message.
    if (!alwaysDirty) {
        setTimeout(function () {
            var initialFormData = new FormData($form[0]);
            initialData = new Map();
            Array.from(initialFormData.keys())
                .filter(function (key) { return !key.startsWith('comments-'); })
                .forEach(function (key) { return initialData.set(key, initialFormData.getAll(key)); });
            var updateDirtyCheck = function () {
                clearTimeout(updateIsDirtyTimeout);
                // If the form is dirty, it is relatively unlikely to become clean again, so
                // run the dirty check on a relatively long timer that we reset on any form update
                // otherwise, use a short timer both for nicer UX and to ensure widgets
                // like Draftail have time to serialize their data
                updateIsDirtyTimeout = setTimeout(updateIsDirty, isDirty ? 3000 : 300);
            };
            $form.on('change keyup', updateDirtyCheck).trigger('change');
            var validInputNodeInList = function (nodeList) {
                var e_1, _a;
                try {
                    for (var nodeList_1 = __values(nodeList), nodeList_1_1 = nodeList_1.next(); !nodeList_1_1.done; nodeList_1_1 = nodeList_1.next()) {
                        var node = nodeList_1_1.value;
                        if (node.nodeType === node.ELEMENT_NODE && ['INPUT', 'TEXTAREA', 'SELECT'].includes(node.tagName)) {
                            return true;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (nodeList_1_1 && !nodeList_1_1.done && (_a = nodeList_1["return"])) _a.call(nodeList_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return false;
            };
            var observer = new MutationObserver(function (mutationList) {
                var e_2, _a;
                try {
                    for (var mutationList_1 = __values(mutationList), mutationList_1_1 = mutationList_1.next(); !mutationList_1_1.done; mutationList_1_1 = mutationList_1.next()) {
                        var mutation = mutationList_1_1.value;
                        if (validInputNodeInList(mutation.addedNodes) || validInputNodeInList(mutation.removedNodes)) {
                            updateDirtyCheck();
                            return;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (mutationList_1_1 && !mutationList_1_1.done && (_a = mutationList_1["return"])) _a.call(mutationList_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            });
            observer.observe($form[0], {
                childList: true,
                attributes: false,
                subtree: true
            });
        }, 1000 * 10);
    }
    // eslint-disable-next-line consistent-return
    window.addEventListener('beforeunload', function (event) {
        clearTimeout(updateIsDirtyTimeout);
        updateIsDirty();
        var displayConfirmation = (!formSubmitted && (isDirty || isCommentsDirty));
        if (displayConfirmation) {
            // eslint-disable-next-line no-param-reassign
            event.returnValue = confirmationMessage;
            return confirmationMessage;
        }
    });
}
window.enableDirtyFormCheck = enableDirtyFormCheck;
jquery_1["default"](function () {
    // Add class to the body from which transitions may be hung so they don't appear to transition as the page loads
    jquery_1["default"]('body').addClass('ready');
    // Enable toggle to open/close nav
    jquery_1["default"](document).on('click', '#nav-toggle', function () {
        jquery_1["default"]('body').toggleClass('nav-open');
        if (!jquery_1["default"]('body').hasClass('nav-open')) {
            jquery_1["default"]('body').addClass('nav-closed');
        }
        else {
            jquery_1["default"]('body').removeClass('nav-closed');
        }
    });
    // Enable toggle to open/close user settings
    // eslint-disable-next-line func-names
    jquery_1["default"](document).on('click', '#account-settings', function () {
        jquery_1["default"]('.nav-main').toggleClass('nav-main--open-footer');
        jquery_1["default"](this).find('em').toggleClass('icon-arrow-down-after icon-arrow-up-after');
    });
    // Resize nav to fit height of window. This is an unimportant bell/whistle to make it look nice
    // eslint-disable-next-line func-names
    var fitNav = function () {
        jquery_1["default"]('.nav-wrapper').css('min-height', jquery_1["default"](window).height());
    };
    fitNav();
    jquery_1["default"](window).on('resize', function () {
        fitNav();
    });
    // Logo interactivity
    function initLogo() {
        var sensitivity = 8; // the amount of times the user must stroke the wagtail to trigger the animation
        var $logoContainer = jquery_1["default"]('[data-animated-logo-container]');
        var lastMouseX = 0;
        var lastDir = '';
        var dirChangeCount = 0;
        function enableWag() {
            $logoContainer.removeClass('logo-serious').addClass('logo-playful');
        }
        function disableWag() {
            $logoContainer.removeClass('logo-playful').addClass('logo-serious');
        }
        $logoContainer.on('mousemove', function (event) {
            var mouseX = event.pageX;
            var dir;
            if (mouseX > lastMouseX) {
                dir = 'r';
            }
            else if (mouseX < lastMouseX) {
                dir = 'l';
            }
            if (dir !== lastDir && lastDir !== '') {
                dirChangeCount += 1;
            }
            if (dirChangeCount > sensitivity) {
                enableWag();
            }
            lastMouseX = mouseX;
            lastDir = dir;
        });
        $logoContainer.on('mouseleave', function () {
            dirChangeCount = 0;
            disableWag();
        });
        disableWag();
    }
    initLogo();
    // Enable nice focus effects on all fields. This enables help text on hover.
    // eslint-disable-next-line func-names
    jquery_1["default"](document).on('focus mouseover', 'input,textarea,select', function () {
        jquery_1["default"](this).closest('.field').addClass('focused');
        jquery_1["default"](this).closest('fieldset').addClass('focused');
        jquery_1["default"](this).closest('li').addClass('focused');
    });
    // eslint-disable-next-line func-names
    jquery_1["default"](document).on('blur mouseout', 'input,textarea,select', function () {
        jquery_1["default"](this).closest('.field').removeClass('focused');
        jquery_1["default"](this).closest('fieldset').removeClass('focused');
        jquery_1["default"](this).closest('li').removeClass('focused');
    });
    /* tabs */
    var showTab = function (tabButtonElem) {
        jquery_1["default"](tabButtonElem).tab('show');
        // Update data-current-tab attribute on the [data-tab-nav] element
        var tabNavElem = tabButtonElem.closest('[data-tab-nav]');
        tabNavElem.dataset.currentTab = tabButtonElem.dataset.tab;
        // Trigger switch event
        tabNavElem.dispatchEvent(new CustomEvent('switch', { detail: { tab: tabButtonElem.dataset.tab } }));
    };
    if (window.location.hash) {
        /* look for a tab matching the URL hash and activate it if found */
        var cleanedHash = window.location.hash.replace(/[^\w\-#]/g, '');
        var tab = document.querySelector('a[href="' + cleanedHash + '"][data-tab]');
        if (tab)
            showTab(tab);
    }
    // eslint-disable-next-line func-names
    jquery_1["default"](document).on('click', '[data-tab-nav] a', function (e) {
        e.preventDefault();
        showTab(this);
        window.history.replaceState(null, null, jquery_1["default"](this).attr('href'));
    });
    // eslint-disable-next-line func-names
    jquery_1["default"](document).on('click', '.tab-toggle', function (e) {
        e.preventDefault();
        jquery_1["default"]('[data-tab-nav] a[href="' + jquery_1["default"](this).attr('href') + '"]').trigger('click');
    });
    // eslint-disable-next-line func-names
    jquery_1["default"]('.dropdown').each(function () {
        var $dropdown = jquery_1["default"](this);
        jquery_1["default"]('.dropdown-toggle', $dropdown).on('click', function (e) {
            e.stopPropagation();
            $dropdown.toggleClass('open');
            if ($dropdown.hasClass('open')) {
                // If a dropdown is opened, add an event listener for document clicks to close it
                jquery_1["default"](document).on('click.dropdown.cancel', function (e2) {
                    var relTarg = e2.relatedTarget || e2.toElement;
                    // Only close dropdown if the click target wasn't a child of this dropdown
                    if (!jquery_1["default"](relTarg).parents().is($dropdown)) {
                        $dropdown.removeClass('open');
                        jquery_1["default"](document).off('click.dropdown.cancel');
                    }
                });
            }
            else {
                jquery_1["default"](document).off('click.dropdown.cancel');
            }
        });
    });
    /* Dropzones */
    // eslint-disable-next-line func-names
    jquery_1["default"]('.drop-zone').on('dragover', function () {
        jquery_1["default"](this).addClass('hovered');
        // eslint-disable-next-line func-names
    }).on('dragleave dragend drop', function () {
        jquery_1["default"](this).removeClass('hovered');
    });
    /* Header search behaviour */
    if (window.headerSearch) {
        var searchCurrentIndex_1 = 0;
        var searchNextIndex_1 = 0;
        var $input_1 = jquery_1["default"](window.headerSearch.termInput);
        var $inputContainer_1 = $input_1.parent();
        $input_1.on('keyup cut paste change', function () {
            clearTimeout($input_1.data('timer'));
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            $input_1.data('timer', setTimeout(search_1, 200));
        });
        // auto focus on search box
        $input_1.trigger('focus');
        // eslint-disable-next-line func-names
        var search_1 = function () {
            var workingClasses = 'icon-spinner';
            var newQuery = $input_1.val();
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            var currentQuery = getURLParam_1('q');
            // only do the query if it has changed for trimmed queries
            // eg. " " === "" and "firstword " ==== "firstword"
            if (currentQuery.trim() !== newQuery.trim()) {
                $inputContainer_1.addClass(workingClasses);
                searchNextIndex_1++;
                var index_1 = searchNextIndex_1;
                jquery_1["default"].ajax({
                    url: window.headerSearch.url,
                    // eslint-disable-next-line id-length
                    data: { q: newQuery },
                    success: function (data) {
                        if (index_1 > searchCurrentIndex_1) {
                            searchCurrentIndex_1 = index_1;
                            jquery_1["default"](window.headerSearch.targetOutput).html(data).slideDown(800);
                            window.history.replaceState(null, null, '?q=' + newQuery);
                        }
                    },
                    complete: function () {
                        window.wagtail.ui.initDropDowns();
                        $inputContainer_1.removeClass(workingClasses);
                    }
                });
            }
        };
        // eslint-disable-next-line func-names
        var getURLParam_1 = function (name) {
            var results = new RegExp('[\\?&]' + name + '=([^]*)').exec(window.location.search);
            if (results) {
                return results[1];
            }
            return '';
        };
    }
    /* Functions that need to run/rerun when active tabs are changed */
    jquery_1["default"](document).on('shown.bs.tab', function () {
        // Resize autosize textareas
        // eslint-disable-next-line func-names
        jquery_1["default"]('textarea[data-autosize-on]').each(function () {
            // eslint-disable-next-line no-undef
            autosize.update(jquery_1["default"](this).get());
        });
    });
    /* Debounce submission of long-running forms and add spinner to give sense of activity */
    // eslint-disable-next-line func-names
    jquery_1["default"](document).on('click', 'button.button-longrunning', function () {
        var $self = jquery_1["default"](this);
        var $replacementElem = jquery_1["default"]('em', $self);
        var reEnableAfter = 30;
        var dataName = 'disabledtimeout';
        // eslint-disable-next-line func-names
        window.cancelSpinner = function () {
            $self.prop('disabled', '').removeData(dataName).removeClass('button-longrunning-active');
            if ($self.data('clicked-text')) {
                $replacementElem.text($self.data('original-text'));
            }
        };
        // If client-side validation is active on this form, and is going to block submission of the
        // form, don't activate the spinner
        var form = $self.closest('form').get(0);
        if (form && form.checkValidity && !form.noValidate && (!form.checkValidity())) {
            return;
        }
        // Disabling a button prevents it submitting the form, so disabling
        // must occur on a brief timeout only after this function returns.
        var timeout = setTimeout(function () {
            if (!$self.data(dataName)) {
                // Button re-enables after a timeout to prevent button becoming
                // permanently un-usable
                $self.data(dataName, setTimeout(function () {
                    clearTimeout($self.data(dataName));
                    // eslint-disable-next-line no-undef
                    cancelSpinner();
                }, reEnableAfter * 1000));
                if ($self.data('clicked-text') && $replacementElem.length) {
                    // Save current button text
                    $self.data('original-text', $replacementElem.text());
                    $replacementElem.text($self.data('clicked-text'));
                }
                // Disabling button must be done last: disabled buttons can't be
                // modified in the normal way, it would seem.
                $self.addClass('button-longrunning-active').prop('disabled', 'true');
            }
            clearTimeout(timeout);
        }, 10);
    });
});
// =============================================================================
// Wagtail global module, mainly useful for debugging.
// =============================================================================
// =============================================================================
// Inline dropdown module
// =============================================================================
var wagtail = window.wagtail || {};
if (!wagtail.ui) {
    wagtail.ui = {};
}
// Constants
var DROPDOWN_SELECTOR = '[data-dropdown]';
var LISTING_TITLE_SELECTOR = '[data-listing-page-title]';
var LISTING_ACTIVE_CLASS = 'listing__item--active';
var ICON_DOWN = 'icon-arrow-down';
var ICON_UP = 'icon-arrow-up';
var IS_OPEN = 'is-open';
var clickEvent = 'click';
var TOGGLE_SELECTOR = '[data-dropdown-toggle]';
var ARIA = 'aria-hidden';
var keys = {
    ESC: 27,
    ENTER: 13,
    SPACE: 32
};
/**
 * Singleton controller and registry for DropDown components.
 *
 * Mostly used to maintain open/closed state of components and easily
 * toggle them when the focus changes.
 */
var DropDownController = {
    dropDowns: [],
    closeAllExcept: function (dropDown) {
        var index = this.dropDowns.indexOf(dropDown);
        this.dropDowns.forEach(function (item, i) {
            if (i !== index && item.state.isOpen) {
                item.closeDropDown();
            }
        });
    },
    add: function (dropDown) {
        this.dropDowns.push(dropDown);
    },
    get: function () {
        return this.dropDowns;
    },
    getByIndex: function (index) {
        return this.dropDowns[index];
    },
    getOpenDropDown: function () {
        var needle = null;
        this.dropDowns.forEach(function (item) {
            if (item.state.isOpen) {
                needle = item;
            }
        });
        return needle;
    }
};
/**
 * DropDown component
 *
 * Template: _button_with_dropdown.html
 *
 * Can contain a list of links
 * Controllable via a toggle class or the keyboard.
 */
function DropDown(el, registry) {
    if (!el || !registry) {
        if ('error' in console) {
            // eslint-disable-next-line max-len, no-console
            console.error('A dropdown was created without an element or the DropDownController.\nMake sure to pass both to your component.');
            return;
        }
    }
    this.el = el;
    this.$parent = jquery_1["default"](el).parents(LISTING_TITLE_SELECTOR);
    this.state = {
        isOpen: false
    };
    this.registry = registry;
    this.clickOutsideDropDown = this.clickOutsideDropDown.bind(this);
    this.closeDropDown = this.closeDropDown.bind(this);
    this.openDropDown = this.openDropDown.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyEvent = this.handleKeyEvent.bind(this);
    el.addEventListener(clickEvent, this.handleClick);
    el.addEventListener('keydown', this.handleKeyEvent);
    this.$parent.data('close', this.closeDropDown);
}
DropDown.prototype = {
    handleKeyEvent: function (e) {
        var validTriggers = [keys.SPACE, keys.ENTER];
        if (validTriggers.indexOf(e.which) > -1) {
            e.preventDefault();
            this.handleClick(e);
        }
    },
    handleClick: function (e) {
        if (!this.state.isOpen) {
            this.openDropDown(e);
        }
        else {
            this.closeDropDown(e);
        }
    },
    openDropDown: function (e) {
        e.stopPropagation();
        e.preventDefault();
        var el = this.el;
        var $parent = this.$parent;
        var toggle = el.querySelector(TOGGLE_SELECTOR);
        this.state.isOpen = true;
        this.registry.closeAllExcept(this);
        el.classList.add(IS_OPEN);
        el.setAttribute(ARIA, false);
        toggle.classList.remove(ICON_DOWN);
        toggle.classList.add(ICON_UP);
        document.addEventListener(clickEvent, this.clickOutsideDropDown, false);
        $parent.addClass(LISTING_ACTIVE_CLASS);
    },
    closeDropDown: function () {
        this.state.isOpen = false;
        var el = this.el;
        var $parent = this.$parent;
        var toggle = el.querySelector(TOGGLE_SELECTOR);
        document.removeEventListener(clickEvent, this.clickOutsideDropDown, false);
        el.classList.remove(IS_OPEN);
        toggle.classList.add(ICON_DOWN);
        toggle.classList.remove(ICON_UP);
        el.setAttribute(ARIA, true);
        $parent.removeClass(LISTING_ACTIVE_CLASS);
    },
    clickOutsideDropDown: function (e) {
        var el = this.el;
        var relTarget = e.relatedTarget || e.toElement;
        if (!jquery_1["default"](relTarget).parents().is(el)) {
            this.closeDropDown();
        }
    }
};
function initDropDown() {
    var dropDown = new DropDown(this, DropDownController);
    DropDownController.add(dropDown);
}
function handleKeyPress(e) {
    if (e.which === keys.ESC) {
        var open_1 = DropDownController.getOpenDropDown();
        if (open_1) {
            open_1.closeDropDown();
        }
    }
}
function initDropDowns() {
    jquery_1["default"](DROPDOWN_SELECTOR).each(initDropDown);
    jquery_1["default"](document).on('keydown', handleKeyPress);
}
jquery_1["default"](document).ready(initDropDowns);
wagtail.ui.initDropDowns = initDropDowns;
wagtail.ui.DropDownController = DropDownController;
// provide a workaround for NodeList#forEach not being available in IE 11
function qsa(element, selector) {
    return [].slice.call(element.querySelectorAll(selector));
}
// Initialise button selectors
function initButtonSelects() {
    qsa(document, '.button-select').forEach(function (element) {
        var inputElement = element.querySelector('input[type="hidden"]');
        qsa(element, '.button-select__option').forEach(function (buttonElement) {
            buttonElement.addEventListener('click', function (e) {
                e.preventDefault();
                inputElement.value = buttonElement.value;
                qsa(element, '.button-select__option--selected').forEach(function (selectedButtonElement) {
                    selectedButtonElement.classList.remove('button-select__option--selected');
                });
                buttonElement.classList.add('button-select__option--selected');
            });
        });
    });
}
jquery_1["default"](document).ready(initButtonSelects);
window.wagtail = wagtail;
